import { Constants } from '../_constants/constants';

export class PasswordUpdateDto {
  userID: string;
  currentPassword: string;
  newPassword: string;
  portalType: string = Constants.portalTypeCode;
}
